import { buildRedeemSolverTx } from './buildRedeemSolverTx.js';
export async function redeemSolver(signer, params) {
    try {
        const request = await buildRedeemSolverTx(signer, params);
        const response = await signer.account.sendTransaction(request, {
            estimateTxDependencies: false,
        });
        await response.waitForResult();
        return response.id;
    }
    catch (error) {
        console.error('Error in Fuel redeemSolver:', error);
        throw error;
    }
}
